import React, { PureComponent } from 'react';
import { ISession } from 'types';
import storeConnect from 'data/store-connect';
import sessionStore, {
  CHART_SERIES,
  setSessionTimestamp,
  updateSessionAttr,
  createSessionAttr,
  removeSessionAttr
} from 'data/session';
// Components
import { SessionMap, SessionChart } from 'components/session';
import Card from 'ui/card';
import ResizeBar from 'components/resize-bar';
import {
  ICON_ROW,
  ICON_BACK,
  ICON_COLUMN,
  ICON_CHART,
  ICON_EDIT,
  ICON_ZOOM_IN,
  ICON_ZOOM_OUT
} from 'icons';
import Button from 'ui/button';
import memoize from 'memoize-one';
import { Loader } from 'ui/loader';
import Chart, { ChartAttributes } from 'components/chart';
import Mouse from 'core/mouse';

const MIN_MAP_WIDTH = 250;
const SHOW_CONTENT = {
  map: 1,
  attributes: 2,
  chart: 3
};
interface SessionInspectProps {
  session: ISession;
  gpsIndex: number;
}

const storeMap = {
  session: () => sessionStore.get(),
  series: () => sessionStore.series,
  attrs: () => sessionStore.attrs,
  timestamp: () => sessionStore.activeTimestamp,
  gpsIndex: () => sessionStore.getTimestampIndex('gps')
};
@storeConnect(storeMap, [sessionStore])
class SessionInspect extends PureComponent<SessionInspectProps> {
  state = {
    leftContent: SHOW_CONTENT.map,
    resize: 0,
    range: false,
    collapseMap: false
  };

  chartRef: React.RefObject<Chart> = React.createRef();

  _series = memoize((session, attrs) => {
    console.log('UPSDATRE SERIES');
    return Object.keys(session.fullData || {}).map(id => ({
      id,
      data: session.fullData[id] || [],
      ...attrs[id]
    }));
  });

  get series() {
    return this._series(this.props.session, this.props.attrs);
  }

  handleChartHover = timestamp => {
    setSessionTimestamp(timestamp);
  };

  handleResize = deltaX => {
    const resize = this.state.resize + deltaX;
    this.setState({
      resize,
      collapseMap: window.innerWidth / 2 + resize < MIN_MAP_WIDTH
    });
  };

  handleZoomIn = () => this.handleZoomTimeout();
  handleZoomOut = () => this.handleZoomTimeout(true);

  handleZoomTimeout = (zoomOut: boolean) => {
    const chart = this.chartRef.current;
    if (Mouse.isMouseDown() && chart) {
      if (zoomOut) chart.zoomOut();
      else chart.zoomIn();
      setTimeout(this.handleZoomTimeout, 50, zoomOut);
    }
  };

  handleCollapseMap = () => this.setState({ collapseMap: true });
  handleOpenMap = () => this.setState({ collapseMap: false, resize: 0 });
  handleShowAttributes = () => {
    this.setState({
      leftContent:
        this.state.leftContent === SHOW_CONTENT.attributes
          ? SHOW_CONTENT.map
          : SHOW_CONTENT.attributes,
      collapseMap: false,
      resize: 0
    });
  };
  handleRange = (fromTime, toTime) => this.setState({ range: [fromTime, toTime] });

  render() {
    const { session, series, timestamp, gpsIndex } = this.props;
    if (!session) return false;
    const { leftContent, range, resize, collapseMap } = this.state;

    if (session.convertFile && !session.converted) {
      return (
        <div className="fill row v-center h-center">
          <Loader message="Converting the session file" />
        </div>
      );
    }

    return (
      <div className="column flex" style={{ height: 'calc(100vh)', overflow: 'hidden' }}>
        <Card className="row tiny-margin tiny-padding">
          <Button icon={ICON_BACK} flat="Back" onClick={() => this.props.history.goBack()} />
          <div className="tiny-margin" />
          <Button square icon={ICON_ROW} raised={!collapseMap} onClick={this.handleOpenMap} />
          <Button square icon={ICON_CHART} raised={collapseMap} onClick={this.handleCollapseMap} />
          <div className="tiny-margin" />
          <Button flat="Compare rides" />
          <div className="flex" />
          <Button icon={ICON_ZOOM_IN} square onMouseDown={this.handleZoomIn} />
          <Button icon={ICON_ZOOM_OUT} square onMouseDown={this.handleZoomOut} />
          <div className="tiny-margin" />
          <Button
            square
            icon={ICON_EDIT}
            flat="Attributes"
            raised={leftContent === SHOW_CONTENT.attributes}
            onClick={this.handleShowAttributes}
          />
          <Button square flat="Trim data" />
        </Card>
        <div className="row flex">
          {!collapseMap && (
            <Card
              className="column"
              style={{ overflow: 'hidden', width: `calc(50% + ${resize}px)` }}
            >
              {leftContent === SHOW_CONTENT.map && (
                <SessionMap
                  session={session}
                  timestamp={timestamp}
                  selectedIndexes={[gpsIndex]}
                  range={range}
                />
              )}

              {leftContent === SHOW_CONTENT.attributes && (
                <ChartAttributes
                  series={series}
                  onChange={updateSessionAttr}
                  onCreate={createSessionAttr}
                  onRemove={removeSessionAttr}
                />
              )}
            </Card>
          )}
          <ResizeBar onResize={this.handleResize} />
          <Card className="flex column">
            <Chart
              ref={this.chartRef}
              series={series}
              onPointHover={this.handleChartHover}
              onRange={this.handleRange}
            />
          </Card>
        </div>
      </div>
    );
  }
}

export default SessionInspect;
